import React from "react";
import { Image, Modal } from "antd";
import "./CustomModal.css";
import closeModal from "../../../assets/close-modal.svg";

const CustomModal = ({
  visible,
  onClose,
  style = {},
  title,
  children,
  className = "",
  headerClassName = "",
  bodyClassName = "",
  footerClassName = "",
  wrapClassName = "",
  footer = null,
  ...rest
}) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      style={style}
      footer={footer}
      className={`custom-modal ${className}`}
      wrapClassName={wrapClassName}
      centered
      closeIcon={
        <img
          src={closeModal}
          alt="close-modal"
          onClick={onClose}
          className="custom-close-icon"
        ></img>
      }
      {...rest}
      title={
        <div className={`custom-modal-header ${headerClassName}`}>{title}</div>
      }
    >
      <div className={`custom-modal-body ${bodyClassName}`}>{children}</div>
    </Modal>
  );
};

export default CustomModal;